import { isStale } from "@seabrookstudios/pitch2table-core";

/**
 * A last-published value that can be shown in the notice.
 * Blank, null, empty string, NaN, and other non-numeric values are not years.
 * Numeric strings are years, matching the value the notice already interpolates.
 * @param {unknown} value
 * @returns {boolean}
 */
export const isLastPublishedYear = (value) => {
  if (typeof value === "number") {
    return Number.isFinite(value);
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!/^-?\d+(\.\d+)?$/.test(trimmed)) {
      return false;
    }
    return Number.isFinite(Number(trimmed));
  }
  return false;
};

/**
 * @param {{ yearLastGameReleased?: unknown, websiteDown?: number }|null|undefined} publisher
 * @returns {boolean}
 */
export const showsNotPublishedSinceNotice = (publisher) => {
  if (!publisher || !isLastPublishedYear(publisher.yearLastGameReleased)) {
    return false;
  }
  return isStale(/** @type {import("@seabrookstudios/pitch2table-core").Publisher} */ (publisher));
};

/**
 * @param {{ yearLastGameReleased?: unknown, websiteDown?: number }|null|undefined} publisher
 * @returns {string|null}
 */
export const notPublishedSinceDetailText = (publisher) => {
  if (!showsNotPublishedSinceNotice(publisher) || !publisher) {
    return null;
  }
  return `Please note this publisher has not published a game since ${publisher.yearLastGameReleased}.`;
};

/**
 * @param {{ yearLastGameReleased?: unknown, websiteDown?: number }|null|undefined} publisher
 * @returns {string|null}
 */
export const notPublishedSinceListText = (publisher) => {
  if (!showsNotPublishedSinceNotice(publisher) || !publisher) {
    return null;
  }
  return `Publisher has not published a game since ${publisher.yearLastGameReleased}.`;
};
